import React, { createContext, useContext, ReactNode } from 'react';

export interface FeatureFlags {
  newEventManagementEnabled: boolean;
  // Add other feature flags here as needed
}

const FeatureFlagContext = createContext<FeatureFlags | undefined>(undefined);

interface FeatureFlagProviderProps {
  children: ReactNode;
  flags: FeatureFlags;
}

export function FeatureFlagProvider({ children, flags }: FeatureFlagProviderProps) {
  return <FeatureFlagContext.Provider value={flags}>{children}</FeatureFlagContext.Provider>;
}

export function useFeatureFlags(): FeatureFlags {
  const context = useContext(FeatureFlagContext);
  if (context === undefined) {
    throw new Error('useFeatureFlags must be used within a FeatureFlagProvider');
  }
  return context;
}

// Individual hook for specific flags (for better DX)
export function useFeatureFlag<K extends keyof FeatureFlags>(flag: K): FeatureFlags[K] {
  const flags = useFeatureFlags();
  return flags[flag];
}
